import axios from 'utils/axios';
import authService from 'services/AuthService';

export const LOGIN_REQUEST = '@account/login-request';
export const LOGIN_SUCCESS = '@account/login-success';
export const SILENT_LOGIN = '@account/acount_user';
export const LOGIN_FAILURE = '@account/login-failure';
export const REGISTER = '@account/register';
export const UPDATE_PROFILE = '@account/update-profile';
export const LOGOUT = '@account/logout';

export function login() {
  return async (dispatch) => {
    try {
      dispatch({ type: LOGIN_REQUEST });

      const { user_name: user } = await authService.getSessionInfo();
      const name = {
        user,
      };

      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          name,
        },
      });
    } catch (error) {
      dispatch({ type: LOGIN_FAILURE });
      throw error;
    }
  };
}

export function setUserData(name) {
  return (dispatch) => dispatch({
    type: SILENT_LOGIN,
    payload: {
      name,
    },
  });
}

export function logout() {
  return async (dispatch) => {
    authService.logout();

    dispatch({
      type: LOGOUT,
    });
  };
}

export function register() {
  return true;
}

export function updateProfile(update) {
  const request = axios.post('/api/account/profile', { update });

  return (dispatch) => {
    request.then((response) => dispatch({
      type: UPDATE_PROFILE,
      payload: response.data,
    }));
  };
}
